import axios from "axios";
import router from "@/router";
import store from "@/store";

/**
 * Cliente privado (con token)
 */
export const PbxHttpClient = axios.create({
  baseURL: process.env.VUE_APP_ROOTAPI,
  headers: {
    "Access-Control-Allow-Origin": process.env.VUE_APP_ROOTAPI,
  },
});

/**
 * Cliente público (sin token)
 */
export const PbxPublicHttpClient = axios.create({
  baseURL: process.env.VUE_APP_ROOTAPI,
  headers: {
    "Access-Control-Allow-Origin": process.env.VUE_APP_ROOTAPI,
  },
});

/**
 * INTERCEPTOR DE RESPUESTAS
 * Detecta token expirado o inválido
 */
PbxHttpClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Evitar bucle si ya está en login
      if (router.currentRoute.name !== "login") {
        // Limpiar sesión
        store.dispatch("passport/RESET_AUTH");

        // Mensaje
        store.commit("layout/SHOW_SNACKBAR", {
          text: "Tu sesión ha expirado. Inicia sesión nuevamente.",
          color: "error",
        });

        // Redirigir
        router.push({ name: "login" }).catch(() => {});
      }
    }

    return Promise.reject(error);
  }
);